// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ActivityReport" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ActivityStatsUnit } from "./activity-stats-unit.enum.gen";
import { ActivityUserRowGenShape } from "./activity-user-row.gen";

export const ActivityReportGenShape = z.strictObject({
  teamName: z.string(),
  rangeStart: z.string().optional(),
  rangeEnd: z.string().optional(),
  units: z.enum(ActivityStatsUnit),
  totalActivity: z.number(),
  docExportsTotal: z.number(),
  users: z.array(ActivityUserRowGenShape),
});
